import {useRef, useEffect, useState} from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import {Toast, ToastContainer} from 'react-bootstrap';

import apiClient from '../services/apiClient';
import LoadingScreen from '../components/LoadingScreen';
import Results from '../components/Results';
import NewRequest from '../components/NewRequest';
import {ExclamationTriangle} from 'react-bootstrap-icons';

function SellMessagingCreator() {
  const [validated, setValidated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isGenerated, setIsGenerated] = useState(false);
  const [result, setResult] = useState('');
  const [error, setError] = useState({errorMessage: '', errorDetails: ''});
  const clearErrors = () => setError({errorMessage: '', errorDetails: ''});
  const [show, setShow] = useState(false);
  const clientNameRef = useRef(null);
  const jobTitleRef = useRef(null);
  const cityRef = useRef(null);
  const positionTypeRef = useRef(null);
  const languageRef = useRef(null);
  const location = 'SellMessaging';

  const handleClose = () => setShow(false);
  const handleNewRequest = () => {
    setShow(false);
    setIsGenerated(false);
    setIsLoading(false);
    setResult('');
    clearErrors();
    clientNameRef.current.value = '';
    cityRef.current.value = '';
    jobTitleRef.current.value = '';
    positionTypeRef.current.value = 'false';
    languageRef.current.value = 'English';
    jobTitleRef.current.focus();
    setValidated(false);
    document.querySelector('form').classList.remove('was-validated');
  };
  const selectAllText = (e) => {
    e.target.select();
  };
  const handleShow = () => setShow(true);

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    }
    if (form.checkValidity() === true) {
      setIsLoading(true);
      clearErrors();
      apiClient
        .post(
          'https://fa-persona-backend-test2.azurewebsites.net/api/generation/sellSheet',
          {
            jobTitle: form.jobTitle.value,
            location: form.city.value,
            isContingent: form.isContingent.value === 'true',
            language: form.language.value,
            clientName: form.clientName.value,
          }
        )
        .then((res) => {
          setResult(res.data);
          setIsLoading(false);
          setIsGenerated(true);
        })
        .catch((error) => {
          console.error('Error generating sell sheet:', error);
          setIsLoading(false);
          setError({
            errorMessage:
              'Failed to generate selling content. Please try again later.',
            errorDetails: JSON.stringify(error),
          });
        });
    }

    setValidated(true);
  };

  useEffect(() => {
    clientNameRef.current.focus();
  });

  return (
    <>
      <div className='panel pt-5 pb-2' id='query-form'>
        <div className={isGenerated || isLoading ? 'd-none' : ''}>
          {' '}
          <div className='p-2 text-center'>
            <div className='container py-2'>
              <div className='banner'></div>
              {error.errorMessage && (
                <ToastContainer
                  position='top-end'
                  className='p-3'
                  style={{marginTop: 60, zIndex: 1}}>
                  <Toast className='persona-error-toast'>
                    <Toast.Body>
                      <strong>
                        <ExclamationTriangle
                          className='me-1 text-danger'
                          style={{marginTop: -2}}
                        />
                        {error.errorMessage}
                      </strong>
                      <textarea
                        readOnly
                        onClick={selectAllText}
                        value={error.errorDetails}
                        style={{width: '100%'}}
                        rows={4}
                      />
                    </Toast.Body>
                  </Toast>
                </ToastContainer>
              )}
              <h6 className='my-4'>
                Fill in the below criteria to generate a selling content.
              </h6>
            </div>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className='container persona-form'>
              <Form.Group controlId='clientName' className='mb-3'>
                <Form.Label className='form-label'>Client Name*</Form.Label>
                <InputGroup hasValidation>
                  <Form.Control
                    type='text'
                    placeholder='Client Name'
                    size='sm'
                    required
                    ref={clientNameRef}
                  />
                  <Form.Control.Feedback type='invalid'>
                    This field can't be empty.
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              <Form.Group controlId='jobTitle' className='mb-3'>
                <Form.Label className='form-label'>
                  Job Title or Job Family*
                </Form.Label>
                <InputGroup hasValidation>
                  <Form.Control
                    type='text'
                    placeholder='Job Title or Job Family'
                    size='sm'
                    ref={jobTitleRef}
                    required
                  />
                  <Form.Control.Feedback type='invalid'>
                    This field can't be empty.
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              <Form.Group controlId='city' className='mb-3'>
                <Form.Label>City and/or Country*</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='City'
                  required
                  size='sm'
                  ref={cityRef}
                />
                <Form.Control.Feedback type='invalid'>
                  Please provide a valid city.
                </Form.Control.Feedback>
              </Form.Group>
              <div className='row'>
                <div className='col mb-4'>
                  <Form.Label htmlFor='isContingent'>Position Type</Form.Label>
                  <Form.Select
                    size='sm'
                    id='isContingent'
                    defaultValue='false'
                    ref={positionTypeRef}>
                    <option value='false'>Permanent</option>
                    <option value='true'>Contractor</option>
                  </Form.Select>
                </div>
                <div className='col mb-4'>
                  <Form.Label htmlFor='language'>Language</Form.Label>
                  <Form.Select
                    id='language'
                    defaultValue='English'
                    size='sm'
                    ref={languageRef}>
                    <option value='English'>English</option>
                    <option value='French'>French</option>
                    <option value='German'>German</option>
                    <option value='Spanish'>Spanish</option>
                    <option value='Portuguese'>Portuguese</option>
                    <option value='Polish'>Polish</option>
                    <option value='Dutch'>Dutch</option>
                    <option value='Norwegian'>Norwegian</option>
                    <option value='Italian'>Italian</option>
                    <option value='Czech'>Czech</option>
                    <option value='Romanian'>Romanian</option>
                    <option value='Chinese'>Chinese</option>
                  </Form.Select>
                  <Form.Control.Feedback type='invalid'>
                    This field can't be empty.
                  </Form.Control.Feedback>
                </div>
              </div>
              <div className='d-grid gap-2 d-sm-flex justify-content-sm-end'>
                <button className='btn btn-primary' type='submit'>
                  Generate
                </button>
              </div>
            </div>
          </Form>
        </div>
        {isLoading && <LoadingScreen />}
        {isGenerated && (
          <>
            <Results content={result} location={'SellMessaging'} />
            <NewRequest handleNewRequest={handleNewRequest} />
          </>
        )}
      </div>
    </>
  );
}

export default SellMessagingCreator;
